import React from 'react';

interface LinkedInProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
    className?: string;
}

const LinkedIn: React.FC<LinkedInProps> = ({ width = 132, height = 175, fill = '#0A66C2', className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 132 175"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-label="LinkedIn Logo"
        >
            <g clipPath="url(#clip0_5266_84162)">
                <path
                    d="M122.029 21.7107H9.83327C7.25622 21.7107 4.78472 22.7344 2.96247 24.5567C1.14022 26.3789 0.116486 28.8504 0.116486 31.4275V143.623C0.116486 146.2 1.14022 148.672 2.96247 150.494C4.78472 152.316 7.25622 153.34 9.83327 153.34H122.029C124.606 153.34 127.077 152.316 128.9 150.494C130.722 148.672 131.746 146.2 131.746 143.623V31.4275C131.746 28.8504 130.722 26.3789 128.9 24.5567C127.077 22.7344 124.606 21.7107 122.029 21.7107ZM39.3492 133.842H19.5592V70.9802H39.3492V133.842ZM29.4405 62.2689C27.1957 62.2562 25.0049 61.5789 23.1446 60.3224C21.2844 59.0658 19.838 57.2864 18.9881 55.2086C18.1382 53.1308 17.9229 50.8478 18.3692 48.6478C18.8156 46.4477 19.9036 44.4292 21.4961 42.8469C23.0885 41.2647 25.114 40.1896 27.3169 39.7574C29.5198 39.3251 31.8013 39.5552 33.8736 40.4184C35.9459 41.2816 37.716 42.7393 38.9606 44.6076C40.2052 46.4759 40.8684 48.671 40.8666 50.9159C40.8878 52.4188 40.6062 53.9107 40.0385 55.3024C39.4709 56.6942 38.6288 57.9575 37.5626 59.0169C36.4963 60.0764 35.2277 60.9103 33.8323 61.469C32.4369 62.0277 30.9433 62.2997 29.4405 62.2689ZM112.294 133.897H92.5128V99.5546C92.5128 89.4265 88.2074 86.3003 82.6497 86.3003C76.7813 86.3003 71.0225 90.7245 71.0225 99.8106V133.897H51.2324V71.0259H70.2638V79.7372H70.5197C72.4302 75.8706 79.1213 69.2617 89.3317 69.2617C100.374 69.2617 112.303 75.8157 112.303 95.0116L112.294 133.897Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_5266_84162">
                    <rect width="131.629" height="131.629" fill="white" transform="translate(0.116486 21.7107)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LinkedIn;
